export const text = {
  NEW_VISIT: 'New visit',
  PROVIDER: 'provider',
  VISIT_TYPE: 'Visit type',
  METHOD: 'Method',
  BOOKING_STATE: 'Booking state',
  VISIT_COST: 'Visit cost',
  TIME: 'Time',
  RESCHEDULE_VISIT: 'Reschedule visit',
}

export const styles = {
  ERROR_STYLE: {
    width: 550,
    height: 'max-content',
    minHeight: 56,
    background: '#fdf5f2',
    zIndex: 10,
    alignItems: 'center',
  },
  ERROR_ICON_STYLE: {
    marginTop: 0,
  },
  OFF_SCREEN: { height: 0, padding: 0, position: 'absolute' },
}

export const MIN_CHARACTERS_TO_SEARCH = 3
